var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFuncaoComparar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-comparar",
    transform: "translate(-698 -904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2205",
    "data-name": "Grupo 2205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2204",
    "data-name": "Grupo 2204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share-files",
    transform: "translate(703 910.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2203",
    "data-name": "Grupo 2203",
    transform: "translate(0 1.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1210",
    "data-name": "Caminho 1210",
    d: "M14.256,20.886a.831.831,0,0,0-.833.833l.018,5.589H2.249V3.268h16.47V6.249a2.072,2.072,0,0,1,1.162-.355h1.2V2.137a.751.751,0,0,0-.75-.75H.75a.751.751,0,0,0-.75.75v26.4a.751.751,0,0,0,.75.752H15.356a.756.756,0,0,0,.559-.25l1.87-2.1V20.888l-3.529,0Z",
    transform: "translate(0 -1.387)",
    fill: "#030104"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1211",
    "data-name": "Caminho 1211",
    d: "M9.809,13.954l4.84-4a.447.447,0,0,0,.039-.673c-.473-.473-5-3.88-5-3.88s-.6-.6-.6.2V7.679H2.135s-.287-.009-.287.364v3.174c0,.519.344.432.344.432H9.235V13.9C9.232,14.561,9.809,13.954,9.809,13.954Z",
    transform: "translate(2.203 3.132)",
    fill: "#030104"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1212",
    "data-name": "Caminho 1212",
    d: "M28.794,3.962H9.209a.749.749,0,0,0-.747.75v26.4a.75.75,0,0,0,.747.75H23.816a.752.752,0,0,0,.559-.25l4.978-5.572a.74.74,0,0,0,.191-.5V4.714A.753.753,0,0,0,28.794,3.962Zm-1.611,19.5-4.465,0h0a.84.84,0,0,0-.587.241.811.811,0,0,0-.241.59l.015,5.589H10.715V5.84h16.47l0,17.623Z",
    transform: "translate(10.086 1.682)",
    fill: "#030104"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1213",
    "data-name": "Caminho 1213",
    d: "M15.449,17.079s.6.6.6-.2V14.8H23s.289.011.289-.362V11.26c0-.519-.342-.43-.342-.43H15.908V8.575c0-.66-.574-.05-.574-.05l-4.842,4a.45.45,0,0,0-.039.675C10.925,13.671,15.449,17.079,15.449,17.079Z",
    transform: "translate(12.287 6.814)",
    fill: "#030104"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_447",
    "data-name": "Ret\\xE2ngulo 447",
    width: 50,
    height: 50,
    transform: "translate(698 904)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoComparar);
export default __webpack_public_path__ + "static/media/ico-funcao-comparar.32478daa26f399924350144b1940a269.svg";
export { ForwardRef as ReactComponent };